import React from 'react';
import * as S from './FarePRiceCard.styles';
import Icon from '../../../../../stories/core-components/IconsSelector';
import { signIn } from './../../../../containers/Common/Utils';
import GoTribeReviewFooter from "../../../../components/GoTribe/ReviewFooter/ReviewFooter";
import { CTA_TYPE } from '../../../../utils/PushEvents/Omniture/utils'
import { pushCtaOmniEvents } from '../../../../utils/PushEvents/Omniture/clickEvents'

const FarePrice = (props) => {
  const { fareBreakup, totalPayFare, isLoggedIn, isCollapsed } = props;
  const { fareMap, fareBreakupObj } = fareBreakup;
  const individualKeysView = getIndividualKeysView(fareBreakupObj);
  const groupedKeysView = getGroupedKeysView(fareMap);


  const finalFareComp = () => {
    return (<>
      {/* {isLoggedIn ? <GoTribeReviewFooter /> : <></>} */}
      <S.TotalPriceRow key={`${isCollapsed ? "collapsedFinalPrice" : "finalPrice"}`}>
        <S.PriceTxtBold>Final Price</S.PriceTxtBold>
        <S.PriceTxtBold>₹{totalPayFare}</S.PriceTxtBold>
      </S.TotalPriceRow>
    </>
    )
  }

  return (
    <S.FareWrapContent>
      {isCollapsed ?
        <>{finalFareComp()}</>
        : <>
          {individualKeysView}
          {groupedKeysView}
          {finalFareComp()}
          {!isLoggedIn ?
            <S.SignInOfferTag onClick={(evt) => {
              pushCtaOmniEvents('Login_banner_selected',CTA_TYPE.HYPER_LINK, 'Personalized Offer Login', 'Home');
              evt.stopPropagation();
              signIn();
            }}>
              <Icon name='GiftIcon' />
              <span style={{ paddingLeft: '0.5rem' }}>Login to get personalized offer.</span>
              <span className="arrowRight"></span>
            </S.SignInOfferTag> : <></>}
        </>}
    </S.FareWrapContent>
  );
}

export default FarePrice;

const getIndividualKeysView = (fareBreakupObj) => {
  let view = [];
  for (const key in fareBreakupObj) {
    if (fareBreakupObj.hasOwnProperty(key)) {
      view.push(<S.TotalPriceRow key={key}>
        <S.PriceTxtBold>{key}</S.PriceTxtBold>
        <S.PriceTxtBold>₹{fareBreakupObj[key]}</S.PriceTxtBold>
      </S.TotalPriceRow>
      );
    }
  }
  return view;
}

const getGroupedKeysView = (fareMap) => {
  let view = [];
  for (const key in fareMap) {
    let groupViewItems = []
    let totalGroupedPrice = 0;

    if (fareMap.hasOwnProperty(key)) {
      const items = fareMap[key].items;
      for (const i in items) {
        totalGroupedPrice += items[i].v;
        groupViewItems.push(
          <S.PriceRow key={items[i].k}>
            <S.PriceTxt>{items[i].k}
            </S.PriceTxt>
            <S.PriceTxt>₹{items[i].v}</S.PriceTxt>
          </S.PriceRow>
        );
      }
    }

    if (groupViewItems && groupViewItems.length) {
      view.push(<S.ToggleWrap key={key}>
        <S.ToggleHeaderInput type="checkbox" id={key}></S.ToggleHeaderInput>
        <S.ToggleHeaderLabel htmlFor={key}>
          <S.PriceTxtBold>{key}</S.PriceTxtBold>
          <S.PriceTxtBold>₹{totalGroupedPrice}</S.PriceTxtBold>

        </S.ToggleHeaderLabel>
        <S.DetailedFairWrap>
          {groupViewItems}
        </S.DetailedFairWrap>
        {false ? <S.NotSignedInTag>
          <S.SignInTxt>Login to use your goCash</S.SignInTxt>
        </S.NotSignedInTag> : null}
      </S.ToggleWrap>
      )
    }
  }
  return view;
}
